import { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { shortcodesApi } from '../../lib/api';
import '../../index.css'
import { Config } from '../../../Common/Config';

// Setup custom shortcodes dropdown
const setupShortcodesDropdown = (editor) => {
  editor.ui.registry.addMenuButton('customDropdown', {
    text: 'Shortcodes',
    fetch: async (callback) => {
      try {
        editor.setProgressState(true);
        const shortcodes = await shortcodesApi.getAll();
        
        const items = shortcodes?.map((sc) => ({
          type: 'menuitem',
          text: sc.label,
          onAction: () => {
            editor.insertContent(sc.code);
          },
        })) || [];
        
        callback(items);
      } catch (err) {
        console.error('Error fetching shortcodes:', err);
        callback([]);
      } finally {
        editor.setProgressState(false);
      }
    },
  });
};

export const RichTextEditor = ({ value, onChange }) => {
  const editorRef = useRef(null);

  return (
    <div 
      className="rounded-lg overflow-hidden" 
      style={{ border: '1px solid #d9d9d9' }}
    >
      <Editor
        apiKey={Config.apiKey}
        onInit={(evt, editor) => (editorRef.current = editor)}
        value={value}
        onEditorChange={(content) => onChange(content)}
        init={{
          height: 400,
          menubar: true,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'help',
            'wordcount',
          ],
          toolbar:
            'undo redo | blocks | link unlink | customDropdown | ' +
            'bold italic forecolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat',
          setup: setupShortcodesDropdown,
          content_style: `
            body { 
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; 
              font-size: 14px;
              line-height: 1.6;
              color: #333;
              padding: 20px;
            }
            h1 { color: #008385; }
            table { border-collapse: collapse; width: 100%; }
            td, th { border: 1px solid #ddd; padding: 10px; }
          `,
          branding: false,
          promotion: false,
          skin: 'oxide',
          content_css: 'default',
        }}
      />
    </div>
  );
};
